import { render } from "./ChartsPosSizeConfiger.vue?vue&type=template&id=57461eb8&scoped=true"
import script from "./ChartsPosSizeConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsPosSizeConfiger.vue?vue&type=script&lang=js"

import "./ChartsPosSizeConfiger.vue?vue&type=style&index=0&id=57461eb8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57461eb8"]])

export default __exports__